var rAF;
if (typeof window !== 'undefined' && window.requestAnimationFrame) {
    rAF = window.requestAnimationFrame.bind(window);
}
else {
    // old browsers
    rAF = function (callback) {
        return Number(setTimeout(callback, 0));
    };
}
export default rAF;
//# sourceMappingURL=requestAnimationFrame.js.map